module.exports = __webpack_public_path__ + "static/media/zoomy4.da8ef650.jpg";